import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

import Frame from 'components/shared/frame';
import Group from 'components/companies/group';
import Loading from 'components/shared/loading';
import CustomHead from 'components/shared/customHead';

import useRedis from 'hooks/cms/redis';
import useContent from 'hooks/content';
import { useApplication } from 'hooks/application';
import { mapCompanies,getMetadataCompanies,joinCompanies } from '/hooks/cms/mappers/mapCompanies';

import useStyles from 'isomorphic-style-loader/useStyles';
import classes from './style.module.scss';
import globalStyles from 'styles/main.scss';
import './translations';

export default () => {
  useStyles(classes, globalStyles);
  const { t } = useTranslation('landingCompanies');
  const { countries,idPv } = useApplication();
  const { getCompanies } = useContent();
  const { getCache } = useRedis();
  const [selectValue, setSelectValue] = useState('all');
  const [filteredCompanies, setFilteredCompanies] = useState();
  const [data, setData] = useState();
  const [dropdownOptions, setDropdownOptions] = useState([]);

  useEffect(() => {
    const getData = async () => {
    const cms = await getCache({ key:'companiesQuery',idPv:idPv });
    const strapiContent = await mapCompanies(cms);

    const content = await getCompanies();
    
    const companies = strapiContent ? await joinCompanies(content.companies,strapiContent?.companies) : content.companies;

    setFilteredCompanies(getCompaniesFilteredByCountry(companies));
    setData(getMetadataCompanies(content,strapiContent));

    }

    getData();
  }, []);



  useEffect(() => {
    const options = countries && countries.map(country => {
      return { label: country.name.toUpperCase(), value: country.url };
    });

    options.unshift({ label: t('all'), value: 'all' });
    setDropdownOptions(options);
  }, [countries.length])

  const getCompaniesFilteredByCountry = companiesGroupedByChar => {
    const countryCodes = countries.map(country => country.url);
    const filteredCompaniesByCountry = countryCodes.reduce((object, currentValue) => {
      return object[currentValue] = filterCompaniesByCountry(companiesGroupedByChar, currentValue), object
    }, {});
    
    return { ...filteredCompaniesByCountry, all: companiesGroupedByChar };
  };

  const filterCompaniesByCountry = (companiesGroupedByChar, country) => {
    return companiesGroupedByChar.map(group => {
        return {
          ...group,
          landings: group.landings.filter(company => company.country === country)
        }
      });
  }

  return (
      data 
        ? <Frame title={t('title')}>
            <CustomHead metadata={data.metadata} />
            <div className={`${globalStyles.flexJustifyCenter} ${globalStyles.textCenter}`}>
              <span>
                { t('subtitle') } 
              </span>
            </div>
            <div className={classes.countryFilterContainer}>
              <span> { t('filter') }  </span>
              <Dropdown 
                options={dropdownOptions} 
                onChange={item => setSelectValue(item.value)}
                value={dropdownOptions[0]} 
              />
            </div>
            {
              filteredCompanies[selectValue].map((group, index) => <Group group={group} key={index} />)
            }
          </Frame>
        : <Loading/>
  );
}